import {
  AlertNotification,
  Button,
  LabeledInput,
  SkubotSpinner,
} from '@commonsku/styles';
import React from 'react';
import styled from 'styled-components';

export interface IntegrationCredentialField {
  label: string;
  value: string;
  onChange: (value: string) => void;
  type?: 'text' | 'password';
  placeholder?: string;
  disabled?: boolean;
}

interface IntegrationCredentialsFormProps {
  isLoading: boolean;
  alertType: React.ComponentProps<typeof AlertNotification>['alertType'];
  alertMessage: React.ReactNode;
  fields: IntegrationCredentialField[];
  submitLabel: React.ReactNode;
  isSubmitting: boolean;
  isSubmitDisabled: boolean;
  onSubmit: () => void;
  submittingSpinnerStyle?: React.CSSProperties;
}

const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 24px;
  margin-top: 24px !important;
  margin-bottom: 24px !important;

  > * {
    flex: 1;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;

const IntegrationCredentialsForm = ({
  isLoading,
  alertType,
  alertMessage,
  fields,
  submitLabel,
  isSubmitting,
  isSubmitDisabled,
  onSubmit,
  submittingSpinnerStyle,
}: IntegrationCredentialsFormProps) => {
  if (isLoading) {
    return <SkubotSpinner style={{ margin: 'auto' }} />;
  }

  return (
    <>
      <AlertNotification alertType={alertType}>{alertMessage}</AlertNotification>
      <InputContainer>
        {fields.map((field, index) => (
          <LabeledInput
            key={`${field.label}-${index}`}
            label={field.label}
            type={field.type}
            placeholder={field.placeholder}
            style={{ marginBottom: 0 }}
            value={field.value}
            disabled={field.disabled}
            onChange={(e) => field.onChange(e.target.value)}
          />
        ))}
      </InputContainer>
      <ButtonContainer>
        <Button
          variant='primary'
          size='medium'
          disabled={isSubmitDisabled}
          onClick={onSubmit}
        >
          {isSubmitting ? (
            <SkubotSpinner
              size='button'
              skubot={false}
              style={submittingSpinnerStyle}
            />
          ) : (
            submitLabel
          )}
        </Button>
      </ButtonContainer>
    </>
  );
};

export default IntegrationCredentialsForm;
